import { render } from "./SmartChat.vue?vue&type=template&id=6a5068bc"
import script from "./SmartChat.vue?vue&type=script&lang=js"
export * from "./SmartChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__